export const assetData = [
  {
    label: "Engine 1",
    value: "engine1",
  },
  {
    label: "Engine 2",
    value: "engine2",
  },
  {
    label: "Engine 3",
    value: "engine3",
  },
  {
    label: "Engine 4",
    value: "engine4",
  },
];

export const selectOption = [
  {
    label: "Diagnostic Data Download",
    value: "data",
  },
  {
    label: "Intelligent Health Report",
    value: "historicReports",
  },
  {
    label: "Webserver Database Download",
    value: "database",
  },
  {
    label: "Alerts Download",
    value: "alerts",
  },
];

export const selectPeriod = [
  {
    label: "Last 1 Month",
    value: "1",
  },
  {
    label: "Last 3 Month",
    value: "3",
  },
];

export const selectReportType = [
  {
    label: "Graphical",
    value: "graphical",
  },
  {
    label: "SpreadSheet",
    value: "spreadsheet",
  },
  {
    label: "Raw Data",
    value: "raw",
  },
  {
    label: "JSON",
    value: "json",
  },
];
